import React, { useState, useRef, useEffect } from 'react';

/* V70.148 — Hızlı Araçlar: Notlarım.
 * Kişisel karalama defteri; kullanıcı bazlı localStorage'da otomatik saklanır
 * (sunucuya gitmez, tarayıcıya özeldir). */

const NotesTool = ({ uid }) => {
  const key = `mtu_ft_notes:${uid}`;
  const [val, setVal] = useState(() => {
    try { return localStorage.getItem(key) || ''; } catch { return ''; }
  });
  const [confirming, setConfirming] = useState(false);
  const confirmTimer = useRef(null);

  useEffect(() => () => clearTimeout(confirmTimer.current), []);

  const save = (v) => {
    setVal(v);
    try { localStorage.setItem(key, v); } catch {}
  };

  const clearAll = () => {
    if (!confirming) {
      setConfirming(true);
      clearTimeout(confirmTimer.current);
      confirmTimer.current = setTimeout(() => setConfirming(false), 2500);
      return;
    }
    setConfirming(false);
    save('');
  };

  return (
    <div className="ftn">
      <textarea
        className="ftn-area"
        placeholder="Hızlı notlar… (otomatik kaydedilir, sadece bu tarayıcıda)"
        value={val}
        maxLength={20000}
        autoFocus
        onChange={e => save(e.target.value)}
      />
      <div className="ftn-foot">
        <button className="ftn-clear" onClick={clearAll}>
          {confirming ? 'Emin misin? Tıkla → sil' : 'Temizle'}
        </button>
        <span>Otomatik kaydedilir</span>
        <span className="ftn-count">{val.length.toLocaleString('tr-TR')} / 20.000</span>
      </div>
    </div>
  );
};

export default NotesTool;
